module.exports = __webpack_public_path__ + "img/top-menu-logo.1817820e.png";